import { formatDateMoment, setNumberWithPoint } from 'utils/utils'
import { Button } from 'avo-ui'
import icTrash from 'assets/images/ic-trash.svg'
import { Link } from 'react-router-dom'

export const TABLE_SPECIAL_GIFT = {
    name: 'Special Gift',
    column: [
        {
            name: 'Nama',
            key: 'name',
            render: ({ item }) => (
                <Link
                    to={`/general-setting/special-gift-list/update-special-gift?giftId=${item?.id}`}
                    className={'capitalize font-medium text-blue-90 hover:font-bold hover:underline'}
                >
                    {item?.name}
                </Link>
            ),
        },
        {
            name: 'Range Pembelanjaan',
            key: 'purchase_range',
        },
        {
            name: 'Jumlah Produk',
            key: 'gift_count',
            render: ({ value }) => <div>{value ? setNumberWithPoint(value) : '-'}</div>,
        },
        {
            name: 'Updated At',
            key: 'updated_at',
            render: ({ value }) => <div>{formatDateMoment(value, 'DD/MM/YYYY HH:mm')}</div>,
        },
        {
            name: 'Action',
            key: 'action',
            render: ({ item, onClickItem }) => (
                <Button type={'outline'} title={'Delete'} icon={icTrash} onClick={() => onClickItem(item?.id)} />
            ),
        },
    ],
}

export const INITIAL_DATA_FILTER = {
    page: 1,
    limit: 20,
}
